import request from '@/utils/request'

/**
 * @typedef {Object} Meter 电表对象
 * @property {string|number} [id] 电表Id
 * @property {string} [uuid] 设备UUID（唯一标识）
 * @property {string} [devId] 设备ID（设备编码）
 * @property {string|number} stationId 电站ID
 * @property {string|number} [unitId] 电站单元ID
 * @property {string} meterName 电表名称
 * @property {number} meterType 电表类型(9:总关口 1:关口电表 2:计量电表 3:并网电表)
 * @property {string} [commInterface] 通信接口
 * @property {string} [factoryName] 厂家名称
 * @property {string} productModel 产品型号
 * @property {number} productRatio 电表变比
 * @property {string} productLocation 安装位置(0:箱变并网柜 1:储能并网柜)
 * @property {string} [imageUrl] 电表图片URL
 * @property {string} [productDescription] 设备描述
 * @property {string} [measuringEquipIdStr] 测量设备关联ID（逗号分隔）
 * @property {string} [assetCode] 资产编号
 * @property {string|number} [assetProperty] 资产性质
 * @property {string} [assetUnit] 资产单位
 * @property {string} [parentMeterUuid] 父级电表UUID（关口-总关口，并网-计量）
 * @property {string} [linkEquipmentUuid] 关联设备UUID（并网、计量关联eLink）
 * @property {number} [sort] 排序号
 */

/**
 * 修改电表
 * @param {Meter} meter
 */
export function updateMeter(meter) {
  return request({
    url: '/device/v3/meter',
    method: 'put',
    data: meter
  })
}

/**
 * 新增电表
 * @param {Meter} meter
 */
export function addMeter(meter) {
  return request({
    url: '/device/v3/meter',
    method: 'post',
    data: meter
  })
}

/**
 * 获取电表列表
 * @param {object} params
 * @param {string|number} params.stationId
 * @param {string|number} [params.unitId]
 * @param {string} [params.meterName]
 * @param {string} [params.productModel]
 * @param {number} [params.meterType]
 * @param {string|number} [params.pageNum]
 * @param {string|number} [params.pageSize]
 */
export function getMeterList(params) {
  return request({
    url: '/device/v3/meter/list',
    method: 'get',
    params: params
  })
}

/**
 * 批量删除电表
 * @param {string|number|string[]|number[]} ids 电表Id
 */
export function delMeterList(ids) {
  if (Array.isArray(ids)) {
    ids = ids.join(',')
  }
  return request({
    url: `/device/v3/meter/${ids}`,
    method: 'delete',
  })
}

/**
 * 获取电表详细信息
 * @param {string|number} id 电表Id
 */
export function getMeter(id) {
  return request({
    url: `/device/v3/meter/${id}`,
    method: 'get',
  })
}

/**
 * 修改meter
 * @param {*} meter
 * @returns
 */
export function update(meter) {
  return request({
    url: '/device/meter',
    method: 'put',
    data: meter
  })
}
/**
 * 新增meter
 * @param {*} meter
 * @returns
 */
export function add(meter) {
  return request({
    url: '/device/meter',
    method: 'post',
    data: meter
  })
}

/**
 * 获取meter列表
 * @param {*} pageNum
 * @param {*} pageSize
 * @param {*} stationId
 * @param {*} unitId
 * @returns
 */
export function list(pageNum, pageSize, stationId, unitId) {
  return request({
    url: '/device/meter/list',
    method: 'get',
    params: {
      pageNum,
      pageSize,
      stationId,
      unitId
    }
  })
}


/**
 * 批量删除meter
 * @param {*} meterIds
 * @returns
 */
export function del(meterIds) {
  return request({
    url: `/device/meter/${meterIds}`,
    method: 'delete',
  })
}


/**
 * 获取meter详细信息
 * @param {*} meterId
 */
export function get(meterId) {
  return request({
    url: `/device/meter/${meterId}`,
    method: 'get',
  })
}


//#region 虚拟电表相关接口
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 
//
//

/**
 * 查询虚拟电表
 * @param {*} stationId 
 * @param {*} meterName 
 * @param {*} pageSize 
 * @param {*} pageNum 
 * @returns 
 */
export function getVMeterList(stationId, meterName = '', pageSize = 65535, pageNum = 1,) {
  return request({
    url: `/device/v2/virtual/meter/list`,
    method: 'get',
    params: {
      stationId,
      meterName,
      pageSize,
      pageNum
    }
  })
}


/**
 * 添加虚拟表
 * @returns 
 */
export function postVMeter(stationId, meterName, addList, subList, uuid) {
  return request({
    url: `/device/v2/virtual/meter`,
    method: 'post',
    data: {
      stationId,
      meterName,
      addList,
      subList,
      uuid,
      type: 1,
    }
  })
}


/**
 * 修改虚拟表
 * @param {*} id 主键ID 必须
 * @param {*} stationId 必须
 * @param {*} meterName 必须
 * @param {*} uuid 非必须 
 * @returns 
 */
export function putVMeter(id, stationId, meterName, addList, subList, uuid) {
  return request({
    url: `/device/v2/virtual/meter`,
    method: 'put',
    data: {
      id,
      stationId,
      meterName,
      addList,
      subList,
      uuid,
      type: 1,
    }
  })
}

/**
 * 删除虚拟表
 * @param {*} id 主键ID 必须
 * @returns 
 */
export function deleteVMeter(id) {
  return request({
    url: `/device/v2/virtual/meter/${id}`,
    method: 'delete',
  })
}
//
//
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//#endregion



